<template>
	<div id="invalid-preset-file-modal" class="modal-new hidden">
		<span class="title">Invalid Preset File</span>
		<p class="description --text-left">
			The file you loaded seems to be invalid or otherwise edited outside LUTs builder. Please make sure you load unedited preset files
			only. If you need to make any changes to a preset file, make sure you edit them inside the LUTs Builder only.
		</p>
		<div class="buttons-continer --single-item">
			<button @click="onConfirm" type="button" class="modal-btn --primary px-20">OK</button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onConfirm() {
			window.UI.hideModal();
			window.UI.showModal(window.UI.modals.presets.save.el);
		},
	},
};
</script>

<style></style>
